import apiClient from '../api/axios';

export interface CreateUserPayload {
  username: string;
  firstName: string;
  email: string;
  password: string;
  organizationId: string;
  status: string;
  mustChangePassword: boolean;
  roleNames: string[];
  type: string;
}

export interface UpdateUserPayload {
  firstName?: string;
  email?: string;
  status?: string;
  mustChangePassword?: boolean;
  roleNames?: string[];
  type?: string;
}

export interface User {
  id: string;
  username: string;
  firstName: string;
  email: string;
  organizationId: string;
  status: string;
  mustChangePassword: boolean;
  roleNames: string[];
  type: string;
}

// Get Users
export const getUsers = async () => {
  const response = await apiClient.get('/admin/users');

  return response.data;
};

// Get User by Id
export const getUserById = async (userId: string) => {
  const response = await apiClient.get(`/admin/users/${userId}`);

  return response.data;
};

// Create User
export const createUser = async (data: CreateUserPayload) => {
  const response = await apiClient.post('/admin/users', data);

  return response.data;
};

// Update User
export const updateUser = async (userId: string, data: UpdateUserPayload) => {
  const response = await apiClient.patch(`/admin/users/${userId}`, data);

  return response.data;
};

// Delete User
export const deleteUser = async (userId: string) => {
  const response = await apiClient.delete(`/admin/users/${userId}`);

  return response.data;
};
